module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/zoom-out-e8d28251053c3dcb08c0dac52ad7d4a4.svg";